
<svg
   xml:space="preserve"
   *ngIf="!dark;else darkTemplate"
   width="1.0732195in"
   height="1.3482293in"
   version="1.1"
   style="clip-rule:evenodd;fill-rule:evenodd;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision;height: 100%;width: 100%;"
   viewBox="0 0 1073.2205 1348.2293"
   id="svg8"
   sodipodi:docname="Secure Sign LOGO_2021-for black background.svg"
   inkscape:export-filename="ss-logo-small.svg"
   inkscape:export-xdpi="96"
   inkscape:export-ydpi="96"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
 <defs
   id="defs1"><style
     type="text/css"
     id="style1">
  </style></defs>
 <g
   id="Layer_x0020_1"
   inkscape:label="Layer 1"
   inkscape:groupmode="layer"
   transform="translate(-2443.86,-3408.68)">
  <metadata
   id="CorelCorpID_0Corel-Layer" />
  
  <g
   id="g9">
   <path
     [ngClass]="{'fill-light':!dark,'fill-dark':dark}"
     d="m 2983.11,3408.68 c 0,0 202.91,266.95 533.97,224.24 0,0 -58.74,149.51 -48.08,325.7 19.98,329.63 -20.43,467.29 -138.86,565.93 -96.06,80.13 -325.3,209.11 -349.67,232.36 -24.35,-23.25 -253.64,-152.23 -349.72,-232.36 -118.39,-98.64 -158.81,-236.3 -138.83,-565.93 10.68,-176.2 -48.06,-325.7 -48.06,-325.7 331.09,42.72 533.95,-224.24 533.95,-224.24 z m -0.34,89.08 c 0,0 176.08,231.67 463.41,194.61 0,0 -50.99,129.74 -41.72,282.66 17.33,286.07 -17.74,405.56 -120.52,491.16 -83.36,69.53 -282.31,181.47 -303.47,201.65 -21.14,-20.18 -220.12,-132.12 -303.51,-201.65 -102.75,-85.6 -137.82,-205.09 -120.48,-491.16 9.27,-152.92 -41.71,-282.66 -41.71,-282.66 287.35,37.07 463.4,-194.61 463.4,-194.61 h 4.61 z"
     id="path8" />
     <path
      [ngClass]="{'fill-light':!dark,'fill-dark':dark}"
     d="m 3141.66,3771.11 v 0 c 3.08,-5.15 12.33,-5.15 17.48,0 3.11,4.12 3.11,11.31 0,16.45 l -149.12,142.98 c -5.17,5.15 -11.34,5.15 -17.51,0 -3.08,-5.16 -3.08,-12.34 0,-15.46 l 149.15,-143.98 z"
     id="path3" /><path
     [ngClass]="{'fill-light':!dark,'fill-dark':dark}"
     d="m 3194.11,3822.54 v 0 c 5.14,-3.09 14.42,-3.09 17.5,0 5.15,5.13 5.15,12.33 0,18.52 l -146.06,142.96 c -5.14,3.09 -12.37,3.09 -18.54,0 -5.13,-6.17 -5.13,-13.35 0,-18.5 z"
     id="path4" /><path
     [ngClass]="{'fill-light':!dark,'fill-dark':dark}"
     d="m 3248.65,3876.01 v 0 c 6.16,-3.07 12.33,-3.07 17.46,0 5.13,5.17 5.13,12.37 0,17.51 l -148.13,142.97 c -3.08,4.11 -12.33,4.11 -15.41,0 -5.13,-5.15 -5.13,-12.35 0,-17.48 l 146.07,-143 z"
     id="path5" /><path
     [ngClass]="{'fill-light':!dark,'fill-dark':dark}"
     d="m 3139.61,4364.61 v 0 c 7.19,0 12.33,6.17 12.33,12.33 0,7.21 -5.14,13.4 -12.33,13.4 h -369.28 c -7.2,0 -12.33,-6.19 -12.33,-13.4 0,-6.17 5.13,-12.33 12.33,-12.33 z"
     id="path6"
     />
     <path
        [ngClass]="{'fill-light':!dark,'fill-dark':dark}" 
        d="m 3083.01,3714.53 c 7.23,-6.17 17.51,-6.17 24.7,0 7.19,6.17 7.19,16.46 0,23.67 l -164.56,159.44 -143,255.09 74.06,70.96 261.27,-139.87 164.57,-158.42 c 7.19,-7.19 17.47,-7.19 24.7,0 5.13,7.21 5.13,17.49 0,22.63 l -165.63,160.46 -5.14,4.12 -477.26,254.06 c -4.1,2.06 -5.13,2.06 -9.25,2.06 h -1.06 c -2.06,0 -4.11,0 -7.19,-2.06 -3.09,-3.07 -3.09,-2.05 -7.19,-7.19 0,-1.04 -2.06,-3.09 -2.06,-7.2 v -2.04 c 0,-1.03 2.06,-3.11 2.06,-6.19 l 263.32,-464.94 2.06,-3.09 165.59,-161.48 z"
        id="path7"
     />
    </g>
 </g>
</svg>

<ng-template #darkTemplate>

  <svg
   class="dark"
   xml:space="preserve"
   width="1.0732195in"
   height="1.3482293in"
   version="1.1"
   style="clip-rule:evenodd;fill-rule:evenodd;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
   viewBox="0 0 1073.2205 1348.2293"
   id="svg8"
   sodipodi:docname="Secure Sign LOGO_2021-for black background.svg"
   inkscape:export-filename="ss-logo-small.svg"
   inkscape:export-xdpi="96"
   inkscape:export-ydpi="96"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
 <defs
   id="defs1"><style
     type="text/css"
     id="style1">
  </style></defs>
 <g
   id="Layer_x0020_1"
   inkscape:label="Layer 1"
   inkscape:groupmode="layer"
   transform="translate(-2443.86,-3408.68)">
  <metadata
   id="CorelCorpID_0Corel-Layer" />
  
  <g
   id="g9"><path
     class="fil3"
     d="m 2983.11,3408.68 c 0,0 202.91,266.95 533.97,224.24 0,0 -58.74,149.51 -48.08,325.7 19.98,329.63 -20.43,467.29 -138.86,565.93 -96.06,80.13 -325.3,209.11 -349.67,232.36 -24.35,-23.25 -253.64,-152.23 -349.72,-232.36 -118.39,-98.64 -158.81,-236.3 -138.83,-565.93 10.68,-176.2 -48.06,-325.7 -48.06,-325.7 331.09,42.72 533.95,-224.24 533.95,-224.24 z m -0.34,89.08 c 0,0 176.08,231.67 463.41,194.61 0,0 -50.99,129.74 -41.72,282.66 17.33,286.07 -17.74,405.56 -120.52,491.16 -83.36,69.53 -282.31,181.47 -303.47,201.65 -21.14,-20.18 -220.12,-132.12 -303.51,-201.65 -102.75,-85.6 -137.82,-205.09 -120.48,-491.16 9.27,-152.92 -41.71,-282.66 -41.71,-282.66 287.35,37.07 463.4,-194.61 463.4,-194.61 h 4.61 z"
     id="path8" /><path
     class="fil3"
     d="m 3141.66,3771.11 v 0 c 3.08,-5.15 12.33,-5.15 17.48,0 3.11,4.12 3.11,11.31 0,16.45 l -149.12,142.98 c -5.17,5.15 -11.34,5.15 -17.51,0 -3.08,-5.16 -3.08,-12.34 0,-15.46 l 149.15,-143.98 z"
     id="path3" /><path
     class="fil3"
     d="m 3194.11,3822.54 v 0 c 5.14,-3.09 14.42,-3.09 17.5,0 5.15,5.13 5.15,12.33 0,18.52 l -146.06,142.96 c -5.14,3.09 -12.37,3.09 -18.54,0 -5.13,-6.17 -5.13,-13.35 0,-18.5 z"
     id="path4" /><path
     class="fil3"
     d="m 3248.65,3876.01 v 0 c 6.16,-3.07 12.33,-3.07 17.46,0 5.13,5.17 5.13,12.37 0,17.51 l -148.13,142.97 c -3.08,4.11 -12.33,4.11 -15.41,0 -5.13,-5.15 -5.13,-12.35 0,-17.48 l 146.07,-143 z"
     id="path5" /><path
     class="fil0"
     d="m 3139.61,4364.61 v 0 c 7.19,0 12.33,6.17 12.33,12.33 0,7.21 -5.14,13.4 -12.33,13.4 h -369.28 c -7.2,0 -12.33,-6.19 -12.33,-13.4 0,-6.17 5.13,-12.33 12.33,-12.33 z"
     id="path6"
      /><path
     class="fil0"
     d="m 3083.01,3714.53 c 7.23,-6.17 17.51,-6.17 24.7,0 7.19,6.17 7.19,16.46 0,23.67 l -164.56,159.44 -143,255.09 74.06,70.96 261.27,-139.87 164.57,-158.42 c 7.19,-7.19 17.47,-7.19 24.7,0 5.13,7.21 5.13,17.49 0,22.63 l -165.63,160.46 -5.14,4.12 -477.26,254.06 c -4.1,2.06 -5.13,2.06 -9.25,2.06 h -1.06 c -2.06,0 -4.11,0 -7.19,-2.06 -3.09,-3.07 -3.09,-2.05 -7.19,-7.19 0,-1.04 -2.06,-3.09 -2.06,-7.2 v -2.04 c 0,-1.03 2.06,-3.11 2.06,-6.19 l 263.32,-464.94 2.06,-3.09 165.59,-161.48 z"
     id="path7"
      /></g>
 </g>
</svg>

</ng-template>